export const paths = ['/reports-preferences', '/reports-preferences/:action'];
